import { render, staticRenderFns } from "./DirDetails.vue?vue&type=template&id=7826048a&scoped=true&"
import script from "./DirDetails.vue?vue&type=script&lang=js&"
export * from "./DirDetails.vue?vue&type=script&lang=js&"
import style0 from "./DirDetails.vue?vue&type=style&index=0&id=7826048a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7826048a",
  null
  
)

export default component.exports